import React from 'react';
import { stats } from '../data/hero';
export function Stats() {
  return <section aria-label="Echte Ergebnisse" className="border-y border-grape/10 bg-white/70" data-id="element-158" data-mp="2wxq9bxqydsbk">
      <div className="mx-auto max-w-5xl px-5 py-8" style={{
      paddingTop: "10px",
      paddingBottom: "10px"
    }} data-id="element-159" data-mp="2ixxq0nhraedm">
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4" data-id="element-160" data-mp="2nws5pgkffmti">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-161" data-mp="2nyv68uj7gych">
              <dt className="font-display text-4xl font-black text-grape sm:text-5xl" data-id="element-162" data-mp="2972zh6xh8smd">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-plum/60" data-id="element-163" data-mp="2dznta8gdv5pw">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}